import PropTypes from 'prop-types';

import { TYPE_ORIGIN } from '@/common/constants';
import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const NotificationDefaultProps = {
  ...BaseDefaultProps,
  datetime: null,
  entityExists: false,
  entityId: null,
  id: null,
  isRead: false,
  message: null,
  object: null,
  onClose: () => {},
  onRead: () => {},
  type: null,
  typeOrigin: null,
};

export const NotificationPropTypes = {
  ...BasePropTypes,
  datetime: PropTypes.string,
  entityExists: PropTypes.bool,
  entityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isRead: PropTypes.bool,
  message: PropTypes.string,
  object: PropTypes.string,
  onClose: PropTypes.func,
  onRead: PropTypes.func,
  type: PropTypes.string,
  typeOrigin: PropTypes.oneOf([
    TYPE_ORIGIN.EB,
    TYPE_ORIGIN.EBC,
    TYPE_ORIGIN.LM,
    null,
  ]),
};
